import { render } from "./index.vue?vue&type=template&id=fbc0e814&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.less?vue&type=style&index=0&id=fbc0e814&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=fbc0e814&lang=less&scoped=true"

import exportComponent from "/Users/zhouti/Desktop/work/fy-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbc0e814"]])

export default __exports__